module.exports = __webpack_public_path__ + "static/img/发展历程-2.1c9d7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/发展历程-2.png
// module id = AffG
// module chunks = 38